import { FC } from "react";
import { FormattedMessage } from "react-intl";

export const EmptyVersionGuide: FC = () => {
  return (
    <div className="flex flex-col justify-center items-center h-full space-y-6 mt-14">
      <p className="font-semibold">
        <FormattedMessage
          id="version.emptyArchived"
          defaultMessage="Adding documents to a version helps you keep your case files organized and up to date. Follow these simple steps to attach documents to the right version."
        />
      </p>

      <div className="mt-8 w-full max-w-4xl">
        <div
          style={{
            position: "relative",
            paddingBottom: "calc(57.666666666666664% + 41px)",
            height: 0,
            width: "100%",
          }}
        >
          <iframe
            src="https://demo.arcade.software/eAjCBaajB4bzVnOQSGdj?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true"
            title="Sky · Add Documents to Version Walkthrough"
            frameBorder="0"
            loading="lazy"
            allowFullScreen
            allow="clipboard-write"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              colorScheme: "light",
            }}
          />
        </div>
      </div>
    </div>
  );
};
